"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _button = require("../global_components/button");

var _button2 = _interopRequireDefault(_button);

var _functional_utility = require("../../../../packages/common-utilities/src/functional_utility");

var _ramda = require("ramda");

var _tracking_utility = require("../../../../packages/common-utilities/src/tracking_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideDrawer = function (_React$Component) {
    _inherits(SlideDrawer, _React$Component);

    function SlideDrawer(props) {
        _classCallCheck(this, SlideDrawer);

        var _this = _possibleConstructorReturn(this, (SlideDrawer.__proto__ || Object.getPrototypeOf(SlideDrawer)).call(this, props));

        _this.state = {
            drawerOpen: props.drawerOpen,
            showScrollComponent: false,
            scrollProgress: 0
        };
        _this.scrollComponent = _react2.default.createRef();
        _this.toggleSlideDrawer = _this.toggleSlideDrawer.bind(_this);
        _this.renderDrawerDesktopView = _this.renderDrawerDesktopView.bind(_this);
        _this.renderDrawerMobileView = _this.renderDrawerMobileView.bind(_this);
        _this.scrollListener = _this.scrollListener.bind(_this);
        _this.moveScroll = _this.moveScroll.bind(_this);
        return _this;
    }

    _createClass(SlideDrawer, [{
        key: "scrollListener",
        value: function scrollListener() {
            if (!this.scrollComponent.current) {
                return;
            }

            var element = this.scrollComponent.current;
            var windowScroll = element.scrollLeft;
            var totalWidth = element.scrollWidth - element.clientWidth;
            if (windowScroll === 0) {
                this.setState({ scrollProgress: 0 });
            } else if (windowScroll > totalWidth) {
                this.setState({ scrollProgress: 100 });
            } else {
                this.setState({ scrollProgress: windowScroll / totalWidth * 100 });
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.props.isMobileView && this.scrollComponent.current != null) {
                this.scrollComponent.current.addEventListener('touchmove', this.scrollListener);
                this.scrollComponent.current.addEventListener("scroll", this.scrollListener);
            } else if (this.scrollComponent.current != null && !this.state.showScrollComponent && this.scrollComponent.current.scrollWidth > this.scrollComponent.current.clientWidth) {
                this.setState({ showScrollComponent: true });
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.props.isMobileView && this.scrollComponent.current != null) {
                this.scrollComponent.current.removeEventListener('touchmove', this.scrollListener);
            }
        }
    }, {
        key: "toggleSlideDrawer",
        value: function toggleSlideDrawer() {
            this.props.openSlideDrawer(!this.props.drawerOpen);
        }
    }, {
        key: "renderDrawerDesktopView",
        value: function renderDrawerDesktopView() {
            var _this2 = this;

            if ((0, _ramda.isNil)(this.props.recommendations) || (0, _functional_utility.isNilOrEmpty)(this.props.recommendations.links)) {
                return null;
            }
            var drawerClasses = this.props.drawerOpen ? 'side-drawer open margin-auto' : 'side-drawer';
            var links = this.props.recommendations.links;
            var contentSlice = links.length === 5 ? 0 : this.props.dynamicContentStart;
            var buttons = [];
            links.slice(contentSlice, contentSlice + 5).map(function (link, index) {
                if (!(0, _functional_utility.isNilOrEmpty)(link.url) && !(0, _functional_utility.isNilOrEmpty)(link.label)) {
                    buttons.push(_this2.renderButton(link.url, link.label, index));
                }
            });
            if (buttons.length === 0) {
                return null;
            }
            return _react2.default.createElement(
                "div",
                { className: drawerClasses },
                _react2.default.createElement(
                    "div",
                    { className: "row position-relative" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
                        _react2.default.createElement(
                            "div",
                            { className: "drawer-title col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xlg-3 font-regular font-20", "data-testid": "drawer-title" },
                            _react2.default.createElement(
                                "span",
                                null,
                                this.props.recommendations.title
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { ref: this.scrollComponent, className: "drawer-buttons col-xs-12 col-sm-12 col-md-6 col-lg-7 col-xlg-7" },
                            buttons.map(function (button) {
                                return button;
                            })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "drawer-action-buttons col-xs-3 col-sm-3 col-md-3 col-lg-2 col-xlg-2" },
                            this.renderScrollControls(),
                            _react2.default.createElement(
                                "div",
                                { onClick: this.toggleSlideDrawer, className: "drawer-close-button", "data-testid": "drawer-close-button" },
                                _react2.default.createElement("span", { className: "slider-arrow right" }),
                                _react2.default.createElement("span", { className: "slider-arrow right" })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: "renderDrawerMobileView",
        value: function renderDrawerMobileView() {
            var _this3 = this;

            var links = this.props.recommendations.links;
            var contentSlice = links.length === 5 ? 0 : this.props.dynamicContentStart;
            var buttons = [];
            links.slice(contentSlice, contentSlice + 5).map(function (link, index) {
                if (!(0, _functional_utility.isNilOrEmpty)(link.url) && !(0, _functional_utility.isNilOrEmpty)(link.label)) {
                    buttons.push(_this3.renderButtonMobile(link.url, link.label, index));
                }
            });
            var selectedDotValue = this.state.scrollProgress * buttons.length / 100;
            if (buttons.length === 0) {
                return null;
            }
            return _react2.default.createElement(
                "div",
                { className: "side-drawer open margin-auto" },
                _react2.default.createElement(
                    "div",
                    { className: "row position-relative" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 margin-top-10" },
                        _react2.default.createElement(
                            "div",
                            { onClick: this.toggleSlideDrawer, className: "drawer-close-button-mobile", "data-testid": "drawer-close-button" },
                            _react2.default.createElement("span", { className: "slider-arrow bottom" }),
                            _react2.default.createElement("span", { className: "slider-arrow bottom" })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "drawer-title-mobile col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 font-regular font-20", "data-testid": "drawer-title" },
                            this.props.recommendations.title
                        ),
                        _react2.default.createElement(
                            "div",
                            { ref: this.scrollComponent, className: "drawer-buttons col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xlg-6 margin-bottom-10" },
                            buttons.map(function (button) {
                                return button;
                            })
                        ),
                        this.renderMobileScrollContainer(buttons, selectedDotValue)
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var arrowPosition = this.props.isMobileView ? "top" : "left";
            if ((0, _functional_utility.isNilOrEmpty)(this.props.dynamicContentStart)) {
                return null;
            } else if (!this.props.drawerOpen) {
                return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "drawer-open-button-wrapper" },
                        _react2.default.createElement(
                            "div",
                            { onClick: this.toggleSlideDrawer, className: "drawer-open-button", "data-testid": "drawer-open-button" },
                            _react2.default.createElement("span", { className: "slider-arrow " + arrowPosition }),
                            _react2.default.createElement("span", { className: "slider-arrow " + arrowPosition })
                        )
                    )
                );
            } else {
                return this.props.isMobileView ? this.renderDrawerMobileView() : this.renderDrawerDesktopView();
            }
        }
    }, {
        key: "renderButton",
        value: function renderButton(url, label, index) {
            return _react2.default.createElement(_button2.default, {
                additionalClassName: "slide-button margin-horizontal-10 back",
                downloadURL: url,
                dataTestLink: "cta-link-" + index,
                dataTest: "cta-link-button",
                text: label,
                openInNewTab: true,
                buttonType: "downloadButtonCTA",
                callBack: function callBack() {
                    return _tracking_utility.TrackingUtility.trackEvent({
                        "eventCategory": 'button',
                        "eventAction": label,
                        "eventLabel": url
                    });
                }
            });
        }
    }, {
        key: "renderButtonMobile",
        value: function renderButtonMobile(url, label, index) {
            return _react2.default.createElement(
                "a",
                { className: "font-regular", href: url, key: index,
                    "data-testid": "cta-link-" + index, target: "_blank", onClick: function onClick() {
                        _tracking_utility.TrackingUtility.trackEvent({
                            "eventCategory": 'button',
                            "eventAction": label,
                            "eventLabel": url
                        });
                    } },
                _react2.default.createElement(
                    "button",
                    {
                        className: "slide-button margin-horizontal-10 back slide-button-mobile",
                        "data-testid": "cta-link-button" },
                    label
                )
            );
        }
    }, {
        key: "renderMobileScrollContainer",
        value: function renderMobileScrollContainer(links, selectedDotValue) {
            return _react2.default.createElement(
                "div",
                { className: "margin-bottom-10 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xlg-6 padding-top-10 margin-top-20 text-center",
                    "data-testid": "scroll-indicator-container" },
                links.map(function (link, index) {
                    var isActive = selectedDotValue >= index && selectedDotValue <= index + 1;
                    return _react2.default.createElement("div", { className: (isActive ? 'active' : '') + " dot", key: index, "data-testid": "scroller-dot" });
                })
            );
        }
    }, {
        key: "renderScrollControls",
        value: function renderScrollControls() {
            var _this4 = this;

            if (!this.state.showScrollComponent) {
                return null;
            }
            return _react2.default.createElement(
                "div",
                { className: "display-inline", "data-testid": "drawer-scroll-controls" },
                _react2.default.createElement("span", { onClick: function onClick() {
                        return _this4.moveScroll(-120);
                    }, className: "slider-arrow left", "data-testid": "drawer-scroll-control-left" }),
                "\xA0\xA0",
                _react2.default.createElement("span", { onClick: function onClick() {
                        return _this4.moveScroll(120);
                    }, className: "slider-arrow right", "data-testid": "drawer-scroll-control-right" })
            );
        }
    }, {
        key: "moveScroll",
        value: function moveScroll(number) {
            var eventLabel = null;
            if (number < 0) {
                eventLabel = 'prev';
            } else {
                eventLabel = 'next';
            }
            _tracking_utility.TrackingUtility.trackEvent({
                "eventCategory": 'pdp',
                "eventAction": 'dynamic cta',
                "eventLabel": eventLabel
            });
            this.scrollComponent.current.scrollLeft += number;
        }
    }]);

    return SlideDrawer;
}(_react2.default.Component);

exports.default = SlideDrawer;